import { navigation } from "./navigation";
import { auth } from "./auth";
import { home } from "./home";
import { chat } from "./chat";
import { settings } from "./settings";
import { common } from "./common";
import { download } from "./download";
import { pricing } from "./pricing";
import { payments } from "./payments";
import { profile } from "./profile";
import { usage } from "./usage";
import { support } from "./support";
import { users } from "./users";
import { blog } from "./blog";
import { features } from "./features";
import { subusers } from "./subusers";
import { dashboard } from "./dashboard";
import { characters } from "./characters";
import { agents } from "./agents";
import { nuvemshop } from "./nuvemshop";
import { models } from "./models";
export const en = {
  translation: {
    navigation,
    auth,
    home,
    users,
    chat,
    settings,
    download,
    pricing,
    payments,
    profile,
    usage,
    support,
    common,
    blog,
    features,
    subusers,
    dashboard,
    characters,
    agents,
    nuvemshop,
    models
  },
};
